const CHAMBER_INSTRUCTION_LINKS: Record<string, string> = {
  "Manage Chamber Profile.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373599-how-to-manage-chamber-profile-",
  "Update Existing Member.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373600-how-to-update-existing-member-in-chamber-dashboard-",
  "Manage Member Perks.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373601-how-to-manage-member-perks-in-the-chamber-dashboard-",
  "Create Member Perks.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373602-how-to-create-member-perks-in-the-chamber-dashboard-",
  "View Active Reward Campaign.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373603-how-to-view-active-rewards-campaign-",
  "Update Rewards Contest.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373604-how-to-update-rewards-contest-",
  "View Previous Rewards.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373605-how-to-view-previous-rewards-",
  "Create Rewards Contest.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373606-how-to-create-rewards-campaign-",
  "PerkLinks.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373608-how-to-work-with-perkslink%E2%84%A2-",
  "Update Member Perks.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373610-how-to-update-member-perks-in-chamber-dashboard-",
  "Manage Members.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373611-how-to-manage-members-in-the-chamber-dashboard-",
  "Create New Member.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373613-how-to-create-a-new-member-from-chamber-dashboard-",
  "Manage Category Member Advertising Activations.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373615-how-to-manage-category-member-advertising-activations-",
  "Activate Category Member Advertising Banner.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373614-how-to-activate-category-member-advertising-banner-",
  "Add and manage member Feature Member Banners.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373616-how-to-add-and-manage-member-feature-member-banners-",
  "Manage Featured Member Banner Activation.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373617-how-to-manage-featured-member-banner-activation-",
  "Activate Featured Member Profile & Perks Banners.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373619-how-to-activate-featured-member-profile-and-perks-banners-",
  "Instruction on Sending Member Credentials":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373618-how-to-send-member-credentials-",
};

const MEMBER_INSTRUCTION_LINKS: Record<string, string> = {
  "Member Dashboard - Create a Perk.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373620-how-to-create-a-perk-in-member-dashboard-",
  "Member Dashboard -  Manage Company Profile.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373621-how-to-manage-company-profile-",
  "Member Dashboard - Category Banners  ACTIVE.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373622-how-to-manage-category-banners-from-member-dashboard-when-they-are-active-",
  "Member Dashboard - Category Banners  INACTIVE.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373625-how-to-contact-chamber-to-activate-the-category-advertising-banners-",
  "Member Dashboard - Update Perk.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373623-how-to-update-a-perk-from-member-dashboard-",
  "Member Dashboard - Manage Company Perks.pdf":
    "https://chamberperksapp.freshdesk.com/en/support/solutions/articles/157000373624-how-to-manage-company-perks-from-member-dashboard-",
};

export const openInstructionPdf = (key: string): void => {
  const url = CHAMBER_INSTRUCTION_LINKS[key];
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const openMemberInstructionPdf = (key: string): void => {
  const url = MEMBER_INSTRUCTION_LINKS[key];
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
